




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import TaftIconButton from '@/components/base-layout/TaftIconButton.vue';

@Component({
  components: { TaftIconButton },
})
export default class TaftModal extends Vue {
  @Prop() title!: string;
  @Prop() subTitle?: string;
  @Prop() show!: boolean;
  @Prop() showCloseButton!: boolean;
  @Prop({ default: true }) bodyDefaultPadding!: boolean;
  @Prop({ default: false }) isAddBottomMargin!: boolean;
  @Prop({ default: false }) isAddBottomMarginDateTime!: boolean;
  @Prop({ default: true}) showModalHeader!: boolean;
}
